import React from "react";
import { Table } from "react-bootstrap";

import { Enumeration, PropertyContent } from "../../utils/interface";
import { Config } from "../../common";
import DeleteButton from "../DeleteButton";
import EditPropertyContentModalForm from "../EditPropertyContentModalForm";

const ListPropertyContents: React.FC<{
  propertyContentTypes: Enumeration[];
  propertyContents: PropertyContent[],
  onDeletePropertyContent: (propertyContentId: number) => void;
  onUpdatePropertyContent: (propertyContent: any) => void;
}> = ({
  propertyContentTypes,
  propertyContents,
  onDeletePropertyContent,
  onUpdatePropertyContent,
}) => {
    return (<>
      <Table striped hover size="sm">
        <thead>
          <th>Preview Content</th>
          <th>ID#</th>
          <th>Type</th>
          <th>Seq#</th>
          <th></th>
          <th></th>
        </thead>
        <tbody>
          {propertyContents.map((propertyContent: PropertyContent) => (
            <tr key={propertyContent.propertyContentId}>
              <td>
                <img
                  id={propertyContent.propertyContentId.toString()}
                  src={`${Config.server.baseUrl}/${propertyContent.contentLocation}`}
                  alt="Preview"
                  style={{ maxWidth: '100px' }}
                />
              </td>
              <td>{propertyContent.propertyContentId}</td>
              <td>{propertyContent.propertyContentTypeEnumDescription}</td>
              <td>{propertyContent.sequenceNum}</td>
              <td>
                <EditPropertyContentModalForm
                  propertyContentTypes={propertyContentTypes}
                  propertyContent={propertyContent}
                  onUpdatePropertyContent={onUpdatePropertyContent}
                />
              </td>
              <td>
                <DeleteButton
                  onClick={() => onDeletePropertyContent(propertyContent.propertyContentId)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>);
  };

export default ListPropertyContents;
